import React from 'react';
import { ComponentsProps, ComponentsOverrides, ComponentsVariants, Theme, AlertProps } from '@mui/material';
import { StyleProps } from './utils/dynamicStyle';
import { ErrorIcon, InfoIcon, SuccessIcon, WarningIcon } from '../../components';

function colorStyle(props: StyleProps<AlertProps>) {
    if (props.ownerState.severity !== undefined) {
        const color =
            props.ownerState.severity === 'warning'
                ? props.theme.palette[props.ownerState.severity].contrastText
                : props.theme.palette[props.ownerState.severity].main;
        return {
            backgroundColor: props.theme.palette[props.ownerState.severity].light,
            color,
        };
    }
    return {};
}
export const MuiAlert: {
    defaultProps?: ComponentsProps['MuiAlert'];
    styleOverrides?: ComponentsOverrides<Theme>['MuiAlert'];
    variants?: ComponentsVariants['MuiAlert'];
} = {
    defaultProps: {
        variant: 'filled',
        severity: 'info',
        iconMapping: {
            success: <SuccessIcon titleAccess="Success" />,
            error: <ErrorIcon titleAccess="Error" />,
            warning: <WarningIcon titleAccess="Warning" />,
            info: <InfoIcon titleAccess="Note" />,
        },
    },
    styleOverrides: {
        root: (props) => [props.theme.typography.body1, colorStyle(props)],
    },
};
